import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Bell, AlarmClock, Flag, Star, Radio } from "lucide-react";
import { api } from "@/lib/api";

export default function DeadlineBanner() {
  const [now, setNow] = useState(Date.now());
  const [notifPerm, setNotifPerm] = useState(
    typeof Notification !== "undefined" ? Notification.permission : "denied"
  );

  const { data: settings } = useQuery({
    queryKey: ["settings-public"],
    queryFn: async () => (await api.get("/settings/public")).data,
    refetchInterval: 30000,
  });

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const race = settings?.race;
  if (!race?.lock_at) return null;

  const ms = (d) => (d ? new Date(d).getTime() : null);
  const lock = ms(race.lock_at);
  const cws = ms(race.captain_window_start);
  const cwe = ms(race.captain_window_end);

  let conf;
  if (race.gara_finita) {
    conf = { label: "Classifiche Ufficiali Pubblicate", target: null, icon: Flag, cls: "text-[#22C55E] border-[#22C55E]/40 bg-[#22C55E]/5", to: "/classifica" };
  } else if (lock && now < lock) {
    conf = { label: "Chiusura Iscrizioni e Blocco Formazioni", target: lock, icon: AlarmClock, cls: "text-[#FF1E27] border-[#FF1E27]/40 bg-[#FF1E27]/5", to: "/mercato" };
  } else if (cws && now < cws) {
    conf = { label: "Formazioni bloccate — Prove in corso. Finestra Capitano apre tra", target: cws, icon: Flag, cls: "text-gray-300 border-[#3F3F4C] bg-[#1A1A1E]", to: "/risultati" };
  } else if (cwe && now <= cwe) {
    conf = { label: "Finestra Cambio Capitano APERTA — chiude tra", target: cwe, icon: Star, cls: "text-[#FFB703] border-[#FFB703]/50 bg-[#FFB703]/10", to: "/mercato" };
  } else {
    conf = { label: "Gara Live in Corso", target: null, icon: Radio, cls: "text-[#FF1E27] border-[#FF1E27]/40 bg-[#FF1E27]/5", to: "/risultati" };
  }

  let countdown = null;
  if (conf.target) {
    const diff = Math.max(0, conf.target - now);
    const d = Math.floor(diff / 86400000);
    const h = Math.floor(diff / 3600000) % 24;
    const m = Math.floor(diff / 60000) % 60;
    const s = Math.floor(diff / 1000) % 60;
    const pad = (n) => String(n).padStart(2, "0");
    countdown = `${d > 0 ? `${d}g ` : ""}${pad(h)}:${pad(m)}:${pad(s)}`;
  }

  const askNotifications = async () => {
    try {
      const p = await Notification.requestPermission();
      setNotifPerm(p);
    } catch (e) {}
  };

  const Icon = conf.icon;
  return (
    <div
      data-testid="deadline-banner"
      className={`mb-3 flex items-center justify-between gap-3 rounded-xl border px-4 py-2.5 ${conf.cls}`}
    >
      <Link to={conf.to} className="flex items-center gap-2.5 min-w-0 hover:opacity-80 transition-opacity">
        <Icon className="w-4 h-4 shrink-0" />
        <span className="font-body-sport text-[11px] sm:text-xs font-bold tracking-widest uppercase truncate">
          {conf.label}
        </span>
        {countdown && (
          <span className="font-time font-bold text-sm sm:text-base tabular-nums shrink-0" data-testid="deadline-countdown">
            {countdown}
          </span>
        )}
      </Link>
      {notifPerm === "default" && (
        <button
          data-testid="enable-notifications-button"
          onClick={askNotifications}
          className="shrink-0 flex items-center gap-1.5 rounded-lg border border-current px-3 py-1.5 min-h-[36px] font-body-sport text-[10px] font-bold tracking-widest uppercase hover:opacity-80 transition-opacity"
        >
          <Bell className="w-3.5 h-3.5" /> Attiva Notifiche
        </button>
      )}
    </div>
  );
}
